import { UnstyledButton } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './CreateMemoryButton.module.scss';
import { Props } from './CreateMemoryButton.props';

const CreateMemoryButton = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <UnstyledButton onClick={onClick} className={styles.container}>
      <div className={styles.icon}>
        <IconPlus />
      </div>

      <span className={styles.text}>{t('community.createAlbum', 'Créer un album')}</span>
    </UnstyledButton>
  );
};

export default CreateMemoryButton;
